/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
} from 'shards-react';

import { FiArrowLeft, FiRefreshCcw } from 'react-icons/fi';

import { dateAndHour } from '../../utils/dateFormatter';

import PageTitle from '../../components/common/PageTitle';
import LoadingContainer from '../../components/layout/LodingContainer';

import { getSignLogsById } from '../../store/modules/logs/actions';

export default function SignLogDetails() {
  const dispatch = useDispatch();
  const { id: selectedId } = useParams();
  const navigate = useNavigate();

  const { signLog, loading } = useSelector((state) => state.logs);

  const getSignLog = useCallback(() => {
    dispatch(getSignLogsById(selectedId));
  }, [dispatch, selectedId]);

  useEffect(() => {
    getSignLog();
  }, [getSignLog, selectedId]);

  function handleBack() {
    navigate(-1);
  }

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Registros de Assinatura"
          subtitle="Logs"
          className="text-sm-left"
        />
      </Row>
      {selectedId && (
        <Row className="mb-3">
          <Col md="6">
            <a
              onClick={handleBack}
              className="text-decoration-none h5 text-primary"
              style={{ cursor: 'pointer' }}
            >
              <span>
                <FiArrowLeft />
              </span>{' '}
              <span className="ml-1">Voltar</span>
            </a>
          </Col>
          <Col md="6" className="text-right">
            <Button disabled={loading} onClick={getSignLog}>
              <span className="text-white">
                <FiRefreshCcw />
              </span>{' '}
              Atualizar
            </Button>
          </Col>
        </Row>
      )}
      {/* Details */}
      {selectedId && signLog && (
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="mt-1 mr-3 mb-0">
                  Detalhes do registro de assinatura
                </h6>
              </CardHeader>
              <CardBody className="p-0 overflow-auto">
                {loading && <LoadingContainer loading={loading} />}
                {!loading && signLog._id && (
                  <>
                    <table className="table m-0">
                      <tbody>
                        <tr>
                          <td>Identificador</td>
                          <td>{signLog._id}</td>
                        </tr>
                        <tr data-tip="client_id">
                          <td>ID do cliente</td>
                          <td>{signLog.client_id}</td>
                        </tr>
                        <tr data-tip="yourNumber">
                          <td>Seu número</td>
                          <td>{signLog.yourNumber}</td>
                        </tr>
                        <tr data-tip="signPolicy">
                          <td>Política de assinatura</td>
                          <td>
                            {signLog.policy && signLog.policy.sign_policy}
                          </td>
                        </tr>
                        <tr data-tip="operationType">
                          <td>Tipo de operação</td>
                          <td>{signLog.operationType}</td>
                        </tr>
                        <tr data-tip="provider">
                          <td>Provedor de assinatura</td>
                          <td>{signLog.provider}</td>
                        </tr>
                        <tr data-tip="status">
                          <td>Status</td>
                          <td>{signLog.status}</td>
                        </tr>
                        <tr data-tip="error">
                          <td>Mensagem de erro</td>
                          <td>{signLog.error}</td>
                        </tr>
                        <tr data-tip="date">
                          <td>Data</td>
                          <td>{dateAndHour(signLog.date)}</td>
                        </tr>
                      </tbody>
                    </table>
                    <ReactTooltip />
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
}
